module.exports = __webpack_public_path__ + "../resources/img/module_icon_test.843797e4.svg";